import { useReducer } from "react";
import styles from "./noRoomTypesFound.module.scss";
import Image from "@Components/Image";
import filtersModalReducer from "@Pages/Search/components/FilterSection/components/FiltersModal/filtersModalReducer";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import { applyPropertyFilter } from "@Pages/PropertyPage/data/propertyPageReducer";
import wrapperHOC from "@Utils/wrapperHOC";
//

const NoRoomTypesFound = () => {
  const { filters } = useSelector(
    ({ propertyPageData }: AppState) => ({
      filters: propertyPageData.filters,
    }),
    shallowEqual,
  );
  const propertyPageDispatch = useDispatch();
  const [, dispatch] = useReducer(filtersModalReducer, filters);
  return (
    <div className={styles.noRoomTypesFoundContainer}>
      <Image
        height={80}
        width={80}
        src="https://prod-static-assets.amberstudent.com/images/empty-search.svg"
        alt="Empty search image"
      />
      <span className={styles.header}>
        propertypage.roomtypesectiondynamic.noroomtypesfound.header
      </span>
      <span className={styles.description}>
        $propertypage.roomtypesectiondynamic.noroomtypesfound.description1$
        propertypage.roomtypesectiondynamic.noroomtypesfound.description2
      </span>
      <button
        type="button"
        className={styles.btn}
        onClick={() => {
          dispatch({ type: "reset", payload: {} });
          propertyPageDispatch(applyPropertyFilter({}));
        }}
      >
        propertypage.roomtypesectiondynamic.noroomtypesfound.clearfiltersbutton
      </button>
    </div>
  );
};

export default wrapperHOC(NoRoomTypesFound, {
  componentName: "NoRoomTypesFound-RoomTypeSection-PropertyPage",
  showForChina: true,
});
